var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "form",
    {
      on: {
        submit: function ($event) {
          $event.preventDefault()
          return _vm.onSubmit.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "Modal",
        {
          attrs: { title: "Invite QRP license member" },
          on: { close: _vm.close },
          scopedSlots: _vm._u([
            {
              key: "footer",
              fn: function () {
                return [
                  _c(
                    "ActionButton",
                    {
                      staticClass: "btn-primary btn-sm",
                      attrs: { type: "submit" },
                    },
                    [_vm._v("Invite")]
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c("FormInput", {
                  attrs: { label: "First Name", type: "text", required: "" },
                  model: {
                    value: _vm.data.firstName,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "firstName", $$v)
                    },
                    expression: "data.firstName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c("FormInput", {
                  attrs: { label: "Last Name", type: "text", required: "" },
                  model: {
                    value: _vm.data.lastName,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "lastName", $$v)
                    },
                    expression: "data.lastName",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "col-sm-12" },
              [
                _c("FormInput", {
                  attrs: {
                    label: "E-mail Address",
                    type: "email",
                    required: "",
                  },
                  model: {
                    value: _vm.data.email,
                    callback: function ($$v) {
                      _vm.$set(_vm.data, "email", $$v)
                    },
                    expression: "data.email",
                  },
                }),
              ],
              1
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }